import { render, staticRenderFns } from "./5.vue?vue&type=template&id=3ea54cf5&scoped=true&"
import script from "./5.vue?vue&type=script&lang=js&"
export * from "./5.vue?vue&type=script&lang=js&"
import style0 from "./5.vue?vue&type=style&index=0&id=3ea54cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea54cf5",
  null
  
)

export default component.exports